import { useState, useEffect, useContext, useMemo } from "react";
import { SiteContext } from "../contexts/SiteContext";
import fetchSite from "../utils/fetchSite";
import placeholder from "../inc/placeholder.jpg";
import { useParams, Link } from "react-router-dom";
import {
	Paper,
	Typography,
	makeStyles,
	Fade,
	Card,
	CardContent,
	CardActionArea,
	CardMedia,
	Button
} from "@material-ui/core";
import LayersIcon from "@material-ui/icons/Layers";
import Loading from "../components/Loading";
import Header from "../components/Header";
import AppBar from "../components/AppBar";
import Breadcrumbs from "../components/Breadcrumbs";
import AdminBar from "../components/AdminBar";
import Banner from "../components/Banner";
import { parse } from 'node-html-parser';

function People() {
	const [loading, setLoading] = useState(true);
	const [people, setPeople] = useState();
	const [peopleInSite, setPeopleInSite] = useState([]);
	const { selectedSite, setSelectedSite } = useContext(SiteContext);
	const { siteSlug } = useParams();

	const useStyles = makeStyles((theme) => ({
		root: {
			flex: 1,
			paddingBottom: "4rem",
		},
		link: {
			textDecoration: 'none'
		},
		main: {
			margin: "0 auto",
			padding: "1rem",
			paddingTop: 0,
			maxWidth: process.env.REACT_APP_MAX_WIDTH,
		},
		paper: {
			padding: "1rem",
			type: "dark",
		},
		card: {
			marginBottom: "1rem",
		},
		cardActionArea: {
			display: "flex",
			justifyContent: "start",
			[theme.breakpoints.down('md')]: {
				flexDirection: 'column'
			}
		},
		personDescription: {
			color: 'black',
			[theme.breakpoints.down('md')]: {
				display: 'none'
			}
		},
		media: {
			paddingBottom: "20%",
			paddingRight: "20%",
			[theme.breakpoints.down('md')]: {
				paddingBottom: "100%",
				paddingRight: "100%"
			}
		},
		personBio: {
			color: 'black',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			display: 'box',
			lineClamp: '6',
			boxOrient: 'vertical'
		}
	}));

	const classes = useStyles();

	// This effect sets the selectedSite based on the :siteSlug (first url parameter)
	useEffect(() => {
		fetchSite(siteSlug, setSelectedSite);
	}, [siteSlug, setSelectedSite]);

	// This effect sets the people and uses the selectedSite._id to make sure it's on the right site
	useEffect(() => {
		async function fetchPeople() {
			let res = await fetch(
				`${process.env.REACT_APP_API_URL}/people?unit.site=${selectedSite._id}&sort=+lastName`,
				{ credentials: "include" }
			);
			res = await res.json();
			if (res.success) {
				setPeople(res.data);
			} else {
				console.error(res.error);
			}
		}
		if (selectedSite) {
			fetchPeople();
		}
	}, [selectedSite]);

	useEffect(() => {
		if (people) {
			let filteredPeople = [];
			people.forEach((person) => {
				let o = person.units.find((unit) => unit.site._id === selectedSite._id);
				if (typeof o === "object") {
					filteredPeople.push(person);
				}
			});
			const filteredWithShortBios = filteredPeople.map(person => {
				let parsedBio = parse(person.bio);
				let bioTextOnly = parsedBio.rawText.slice(0, 1000) + '...';
				return { ...person, "bio": bioTextOnly }
			})
			setPeopleInSite(filteredWithShortBios);
			setLoading(false);
		}
	}, [people]);

	const fullName = (person) => {
		let name = "";
		if (person.firstName) {
			name += person.firstName;
		}
		if (person.middleName) {
			name += " " + person.middleName;
		}
		if (person.lastName) {
			name += " " + person.lastName;
		}
		if (person.suffix) {
			name += " " + person.suffix;
		}
		if (person.title) {
			name += ", " + person.title;
		}
		return name;
	};

	if (loading || !selectedSite || !peopleInSite) {
		return <Loading />;
	}

	return (
		<Fade in={typeof peopleInSite != "undefined"}>
			<div className={classes.root}>
				<AdminBar />
				<Header />
				<AppBar />
				<Banner />
				<Breadcrumbs
					links={[
						{
							name: "People",
							url: `/${selectedSite.slug}/people`,
						},
					]}
				/>
				<main className={classes.main}>
					<Paper className={classes.paper}>
						<Typography
							className={classes.title}
							gutterBottom
							component="h2"
							variant="h6"
						>
							<LayersIcon /> All People
						</Typography>
						{
							peopleInSite.map((person, index) => {
								console.log(person)
								return (
									<Card key={index} className={classes.card}>
										<Link
											className={classes.link}
											to={`/${selectedSite.slug}/people/${person.slug}`}
										>
											<CardActionArea className={classes.cardActionArea}>
												<CardMedia
													className={classes.media}
													image={
														person.featuredImage
															? `${process.env.REACT_APP_FILE_URL}/${person.featuredImage.thumbnailName}`
															: placeholder
													}
													title={person.title}
												/>
												<CardContent className={classes.cardContent}>
													<Typography variant="h6" component="h4">
														{fullName(person)}
													</Typography>
													<Typography
														component="p"
														className={classes.personBio}
														dangerouslySetInnerHTML={{ __html: person.bio }}
													></Typography>
													<Button variant="contained" style={{ marginTop: '1rem' }}>Read More</Button>
												</CardContent>
											</CardActionArea>
										</Link>
									</Card>
								)
							})
						}
					</Paper>
				</main>
			</div>
		</Fade>
	);
}

export default People;
